import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";
  import dayjs from "dayjs";
  import { EstateInterface } from "@/types/EstateInterface";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { ReportsTimePeriod } from "@/enums/ReportsTimePeriod";
  import LotsOnClicksFromAnalytics from "@/components/reportsLandowner/LotsOnClicksFromAnalytics.vue";
  import ReferrerFromAnalytics from "@/components/reportsLandowner/ReferrerFromAnalytics.vue";
  import ConversionFromAnalytics from "@/components/reports/ConversionFromAnalytics.vue";
  import BuyerType from "@/components/reportsLandowner/BuyerType.vue";
  import BuyerLocation from "@/components/reportsLandowner/BuyerLocation.vue";
  import LotStatusCount from "@/components/reportsLandowner/LotStatusCount.vue";
  import LotStatusPrice from "@/components/reportsLandowner/LotStatusPrice.vue";
  import Holds from "@/components/reportsLandowner/Holds.vue";
  import HoldsCancelled from "@/components/reportsLandowner/HoldsCancelled.vue";
  import ConversionLeads from "@/components/reportsLandowner/ConversionLeads.vue";
  import DatePicker from "@/components/ui/DatePicker.vue";
  import getEstatesByLandowner from "@/helpers/analytics/getEstatesByLandowner";
  import { ReportsEstateSelected } from "@/enums/ReportsEstateSelected";
  import { formatDateToday, formatDateYYYYMMDD } from "@/helpers/date";
  import { ANALYTICS_REPORT_MIN_DATE } from "@/constants/dataForAnalytics";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsView',
  props: {
    isActiveBurger: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const landownerId = computed(() => store.state.user.data._id);

  const today = dayjs();
  const startDate = ref(dayjs(today.subtract(90, "day")));
  const endDate = ref(today);
  const minEndDate = computed(() =>
    formatDateYYYYMMDD(startDate.value.toString())
  );

  const store = useStore();
  const loading = ref(false);
  const showReports = ref(false);
  const searchKey = ref(0);

  const estates = ref<EstateInterface[]>([]);
  const estateSelected = ref<string>(ReportsEstateSelected.ALL_PROJECTS);

  watch(startDate, (newStartDate) => {
    const start = dayjs(startDate.value.toString());
    const end = dayjs(endDate.value.toString());

    if (start.isAfter(end)) {
      endDate.value = newStartDate;
    }
  });

  const optionsEstate = computed(() => [
    ReportsEstateSelected.ALL_PROJECTS,
    ...estates.value.map((estate) => estate.title),
  ]);

  const onSelectEstate = (estateTitle: string) => {
    estateSelected.value = estateTitle;
  };

  const searchReports = () => {
    if (startDate.value && endDate.value) {
      showReports.value = true;
      searchKey.value++;
    }
  };

  const fetchEstatesByLandowner = () => {
    getEstatesByLandowner(landownerId.value, estates);
  };

  onMounted(() => {
    fetchEstatesByLandowner();
  });

const __returned__ = { props, landownerId, today, startDate, endDate, minEndDate, store, loading, showReports, searchKey, estates, estateSelected, optionsEstate, onSelectEstate, searchReports, fetchEstatesByLandowner, ref, onMounted, computed, watch, get useStore() { return useStore }, get useToast() { return useToast }, get dayjs() { return dayjs }, get EstateInterface() { return EstateInterface }, DropDown, get ReportsTimePeriod() { return ReportsTimePeriod }, LotsOnClicksFromAnalytics, ReferrerFromAnalytics, ConversionFromAnalytics, BuyerType, BuyerLocation, LotStatusCount, LotStatusPrice, Holds, HoldsCancelled, ConversionLeads, DatePicker, get getEstatesByLandowner() { return getEstatesByLandowner }, get ReportsEstateSelected() { return ReportsEstateSelected }, get formatDateToday() { return formatDateToday }, get formatDateYYYYMMDD() { return formatDateYYYYMMDD }, get ANALYTICS_REPORT_MIN_DATE() { return ANALYTICS_REPORT_MIN_DATE } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})